// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityLifetime {
    static getAttributeTypeMap() {
        return MedicalEligibilityLifetime.attributeTypeMap;
    }
}
MedicalEligibilityLifetime.discriminator = undefined;
MedicalEligibilityLifetime.additionalProperties = false;
MedicalEligibilityLifetime.attributeTypeMap = [
    {
        "name": "maximumAmount",
        "baseName": "maximumAmount",
        "type": "string"
    },
    {
        "name": "maximumExists",
        "baseName": "maximumExists",
        "type": "boolean"
    },
    {
        "name": "maximumMet",
        "baseName": "maximumMet",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityLifetime.js.map